import { OrderJobTask } from "@/redux/slices/slice_types";

export const cleanTaskUpdatePayload = (task: OrderJobTask, payload: any) => {
	const properties = task.extra_meta_schema.properties;
	const readOnlyPropertyKeys = Object.keys(task.extra_meta_schema.properties).filter((key) => properties[key].readOnly);
	const validPayloadKeys = Object.keys(payload).filter((key) => !readOnlyPropertyKeys.includes(key));

	const cleanedPayload: any = {};

	validPayloadKeys.forEach(key => {
		cleanedPayload[key] = payload[key];
	});

	return cleanedPayload;
};